


















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

type Type = 'border' | 'text';
type Size = 'small' | 'medium' | 'large';

interface BtnConfig {
  type: Type,
  size?: Size,
  icon?: string,
  text?: string,
  tip?: string,
  disabled?: boolean,
  loading?: boolean,
}

@Component({
  name: 'mcBtn'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private config!: BtnConfig;
  private defaultConfig: any = {
    size: 'medium'
  };

  // 合并默认数据
  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  @Emit('click')
  handleClick(event: any, data: any = {}) {
    data.setDisabled = this.setDisabled;
    data.setLoading = this.setLoading;
  }

  setDisabled(disabled: boolean = true) {
    this.config.disabled = disabled;
  }

  setLoading(isLoading: boolean = true) {
    this.config.loading = isLoading;
  }
}
